import './ObjectNavigator.css';

import { FC } from 'react';
import { IonIcon } from '@ionic/react';
import { chevronBackOutline, chevronForwardOutline } from 'ionicons/icons';
import Button from '../../../../Button/Button';
import { useTranslate } from '../../../../../hooks/context/useTranslate';
import { useLayoutEditorContext } from '../../../../../hooks/context/useLayoutEditorContext';

// Prev/next arrows in the object form for stepping through the canvas objects
// (wraps around).
const ObjectNavigator: FC = () => {
  const { t } = useTranslate();
  const { objects, selectedIndex, selectObject } = useLayoutEditorContext();

  const hasMultipleObjects = objects.length > 1;

  const handleStep = (step: number): void => {
    if (selectedIndex === null) {
      return;
    }

    selectObject((selectedIndex + step + objects.length) % objects.length);
  };

  if (selectedIndex === null) {
    return null;
  }

  return (
    <div className="object-navigator">
      <Button
        fill="clear"
        small
        title={t('layoutEditor.prevObject')}
        disabled={!hasMultipleObjects}
        onClick={(): void => handleStep(-1)}
      >
        <IonIcon icon={chevronBackOutline} slot="icon-only" />
      </Button>
      <span className="object-navigator-counter">
        {selectedIndex + 1} / {objects.length}
      </span>
      <Button
        fill="clear"
        small
        title={t('layoutEditor.nextObject')}
        disabled={!hasMultipleObjects}
        onClick={(): void => handleStep(1)}
      >
        <IonIcon icon={chevronForwardOutline} slot="icon-only" />
      </Button>
    </div>
  );
};

export default ObjectNavigator;
